import { MARKETPLACE_ID } from '@amzn/sss-website-theme';

export interface MarketplaceTaxInfo {
  /** Tax type label (e.g. 'VAT' for UK, 'Tax' for US) */
  type: string;
  /** Tax rate as a percentage (e.g. 20 for 20%) */
  rate: number;
}

/**
 * Returns the tax type and rate for a given marketplace.
 * - EU (UK): VAT at 20%
 * - NA (US): Tax at 0%
 */
export const getMarketplaceTaxInfo = (marketplaceId: string | undefined): MarketplaceTaxInfo => {
  switch (marketplaceId) {
    case MARKETPLACE_ID.EU:
      return { type: 'VAT', rate: 20 };
    case MARKETPLACE_ID.NA:
    default:
      return { type: 'Tax', rate: 0 };
  }
};
